import { createAsyncThunk } from "@reduxjs/toolkit";
import imageApi from "api/imageApi";
import { formatQueryParams } from "helpers/format";

export const postSiteImageCategory = async (data: any = {}) => {
  try {
    const response = await imageApi.postSiteImageCategory(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getImageSearchByCategory = async (params: any = {}) => {
  try {
    const response = await imageApi.getImageSearchByCategory(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postConvertToCdn = async (data: any = {}) => {
  try {
    const response = await imageApi.postConvertToCdn(data);
    return response;
  } catch (error) {
    return error;
  }
};

// Image Library

export const getImageLibraryNormal = async (params: any = {}) => {
  try {
    const response = await imageApi.imageLibraries(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllImageLibraryTags = async (params: any = {}) => {
  try {
    const response = await imageApi.getAllImageLibraryTags(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getImageLibrary = async (id: string | number, params: any = {}) => {
  try {
    const response = await imageApi.getImageLibrary(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postImageLibrary = async (data: any = {}) => {
  try {
    const response = await imageApi.postImageLibrary(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putImageLibrary = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.putImageLibrary(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteImageLibrary = async (data: any = {}) => {
  try {
    const response = await imageApi.deleteImageLibrary(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const importImageBulkByExcel = async (data: any = {}) => {
  try {
    const response = await imageApi.importImageBulkByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const patchImageLibrary = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.patchImageLibrary(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleImageBulkExcel = async (params: any = {}) => {
  try {
    const response = await imageApi.getTemplateSampleImageBulkExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postImageLibraryFavorite = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.postImageLibraryFavorite(id, data);
    return response;
  } catch (error) {
    return error;
  }
};